import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Auth, { CognitoUser } from '@aws-amplify/auth';
import { environment } from '@env/environment';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { BehaviorSubject, from, map, Observable } from 'rxjs';

import { DataUser } from '../models/userRoles..model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: CognitoUser | any;
  user$: BehaviorSubject<CognitoUser | any>;

  constructor(private http: HttpClient) {
    this.user = this.getUser();
    this.user$ = new BehaviorSubject<CognitoUser | any>(this.user);
  }

  getUser(): Observable<CognitoUser | any> {
    return this.user;
  }

  getUserAttributes(): CognitoUserAttribute[] | any {
    return this.user?.attributes;
  }

  setUser(user: CognitoUser | any): void {
    this.user = user;
    this.user$.next(user);
  }

  updateUserAttributes(user: CognitoUser | any, attributes: object): Observable<string> {
    return from(Auth.updateUserAttributes(user, attributes));
  }

  getCurrentAuthenticatedUser(): Observable<CognitoUser | any> {
    return from(Auth.currentAuthenticatedUser());
  }

  getUserRoles(): Observable<DataUser> {
    return this.http.get(environment.AURORA_API + '/GetUserById').pipe(map((res: any) => res));
  }

  isAdmin(): boolean {
    const als =
      'WyJhbGxhbi5jaGFkd2lja0B2ZXJhY2lvLmNvbSIsICJnbGVuLmJyYWJoYW1AdmVyYWNpby5jb20iLCAiaGFsaW5hLmtvbmRyYXNvdmFzQHZlcmFjaW8uY29tIiwgInBoaWwuc3ltb25zQHZlcmFjaW8uY29tIiwgInRvcmJqb3JuLnN2ZW5zc29uQHZlcmFjaW8uY29tIiwgImdlb3JnaW5hLmdvcmRvbkB2ZXJhY2lvLmNvbSIsICJuaXJhdi5oYWxiZUB2ZXJhY2lvLmNvbSIsICJzaGF1bmEuZWRtb25kQHZlcmFjaW8uY29tIiwgInl1bGlhLnV2YXJvdmFAdmVyYWNpby5jb20iLCAic29oYW0uc2V2YWtAdmVyYWNpby5jb20iLCAidGltb3RoeS5qb2huc0B2ZXJhY2lvLmNvbSIsICJsdWtlLmdlb3JnZUB2ZXJhY2lvLmNvbSIsICJuaWtvbGFzLmdvcGNldmljQHZlcmFjaW8uY29tIiwgImNocmlzdGlhbi5wb25jZUB2ZXJhY2lvLmNvbSJd';
    const al = JSON.parse(atob(als));
    const userAttrs = this.getUserAttributes();
    return userAttrs?.email && al.includes(userAttrs.email);
  }
}
